import * as ReactDOM from 'react-dom';
import React, { Component, useState, useEffect,createElement  } from 'react';
import './common.css';
import Usersession from './Usersession';
import axios from 'axios';
import Configdata from './Defaultdata';
import chatlnpfp from './Userpfpc';
import usrf1 from './imgs/grlpfp.png';
import usrm1 from './imgs/boypfp.png';
import {unmountComponentAtNode} from 'react-dom';
import Girlspfp from './Girlspics';
import Boyspfp from './Boyspics';

export const Chtuser=(txt:any)=>{
var userchats = [
		 {uid:0,msg:'',pfpid:0,utid:0,uname:'',code:'#ffff',utype:true},
		 
		];
//alert(JSON.stringify(txt));
if(txt) userchats = txt;
const scrolling=()=>{
const buffer = document.getElementById('chatscrollarea') as HTMLElement;
if(buffer){
 const cht = buffer.clientHeight;
 const h = buffer.scrollHeight-buffer.scrollTop;
 //alert(h);
 if (h < 369) 
 Configdata.ischatscroll = true;
  else  
  Configdata.ischatscroll = false;
}
};
return(
     <div>
      <div className="per100" id="postmain">
	 <div id="chatscrollarea" onScroll={scrolling} className="postinchat" style={{overflowX:'hidden',overflowY:'auto',height:'50vh'}}>
	  <div className="postingchatdiv">

	    <table className="postingtable" style={{height:'auto'}}>
		
		
		
		<tbody>
			{userchats.map((row,index)=>(
			<tr>
			   <td>
			    <div style={{width:'100%'}}>
                        	<div className='chatimgdv'>
				{row.utype?(
	  			 <Girlspfp  itemid={row.pfpid} wth={'20px'}  hgt={'20px'}/>

          			):(
          			
                               <Boyspfp  itemid={row.pfpid} wth={'20px'}  hgt={'20px'}/>

				)}
				
			     </div>
                             <div style={{color:row.code}} className='chatunamedv' >
			   	{row.uname}
			      </div> 
			   </div>
                          <div style={{width:'100%',height:'auto'}}>
                            <div className='chatimgdv'>
			    </div>	
			     <div style={{color:row.code,backgroundColor:'transparent'}} className='chatunamedv' >
			   	{row.msg}
			      </div> 

			   </div>	   
			   </td>
                           
			</tr>
			))}
		 </tbody>	
		
	   </table>
	 </div>		
	</div>
	
	</div>

     </div>
);

}

